export default __webpack_public_path__ + "static/media/earphones8.19537df6.jfif";